<template>
  <div class="container">
<!--    <Title :title="route"></Title>-->
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form :model="detail" label-position="left" label-width="150px">
        <el-divider content-position="left">申请人信息</el-divider>
        <el-form-item label="申请人">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>
        
        <el-divider content-position="left">申述信息</el-divider>
        
        <el-form-item label="申述类型">
          <el-radio-group v-model="detail.allegeType + ''">
            <el-radio label="3">请假</el-radio>
            <el-radio label="4">外出</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="证明文件">
<!--          <el-image -->
<!--            style="width: 100px; height: 100px"-->
<!--            :src="cover" -->
<!--            :preview-src-list="detail.files">-->
<!--          </el-image>-->
          <div style="display: flex; flex-wrap: wrap; gap: 10px;">
            <el-image
                v-for="(item, index) in detail.files"
                :key="index"
                style="width: 100px; height: 100px; border-radius: 6px;"
                :src="item"
                :preview-src-list="detail.files"
                fit="cover"
            />
          </div>
        </el-form-item>
        
        <el-form-item label="申述说明">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit v-model="detail.remark" readonly></el-input>
        </el-form-item>
        
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>
        <div v-if="allowAudit===true">
          <el-divider content-position="left">我要审批</el-divider>
          <el-form-item label="审批意见" prop="remarks">
            <el-input
              type="textarea" rows="5"
              maxlength="500" show-word-limit
              v-model="ruleForm.auditOpinion">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <Setp :nodes="nodes" :audits="audits"></Setp>
  </div>
</template>

<script>
import Title from "../../Title";
import Setp from "../common/Setp";
import AuditList from "../common/AuditList";
import {minioServer} from "@/util";
import {requestApplyDetail, requestAudit, requestAuditShow} from "@/api";
export default {
  components: {Title, Setp, AuditList},
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '考勤申述详情',
        path:''
      },
      dialogVisible: false,
      user: {},
      auditHistory: [],
      allowAudit: false,
      nodes: [],
      audits: [],
      detail: {},
      ruleForm: {
        auditOpinion: "",
      },
      cover: "",
      recordDetail: {}
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.param = {
      applyId: this.query.applyId,
      applyServiceId: this.query.applyServiceId,
      applyType: this.query.applyType
    }
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({applyId: this.param.applyId}).then(res => {
        if (res.code === 200) {
          this.allowAudit = res.object === 1
        }
      })
    },
    async getObject() {
      const res = await requestApplyDetail(this.param)
      if (res.code === 200) {
        if (res.object) {
          this.detail = res.object.detail
          this.audits = res.object.audits
          this.auditHistory = res.object.auditHistory
          this.user = res.object.user
          this.nodes = res.object.nodes
          for (let i = 0; i < this.detail.files.length; i++) {
            this.detail.files[i] = minioServer + this.detail.files[i]
          }
          this.cover = this.detail.files[0]
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    async audit(isAgree) {
      this.allowAudit = false
      let param = this.param
      param.auditOpinion = isAgree === 2 ? "同意" : "不同意"
      if (this.ruleForm.auditOpinion) {
        param.auditOpinion = this.ruleForm.auditOpinion
      }
      param.isAgree = isAgree
      const res = await requestAudit(param)
      if (res.code === 200) {
        this.getAuditShow()
        await this.getObject()
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    }
  }
}
</script>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
  background-color: #F2F6FC;
}
</style>